import React from "react";
import { Button, Modal, Typography } from "antd";
import { CloseOutlined, FileOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

type Props = {
  open: boolean;
  title: string;
  uploadMeta: string;
  accept: string;
  selectedFile: File | null;
  setSelectedFile: (file: File | null) => void;
  error?: string;
  onClose: () => void;
  onSubmit: () => void;
  submitting?: boolean;
};
const UploadDatasetModal: React.FC<Props> = ({
  open,
  title,
  uploadMeta,
  accept,
  selectedFile,
  setSelectedFile,
  error,
  onClose,
  onSubmit,
  submitting = false,
}) => {
  const { t } = useTranslation("dataCleaning");
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={520}
      className="upload-dataset-modal"
    >
      <div className="upload-dataset-modal__header">
        <div />
        <CloseOutlined
          className="upload-dataset-modal__close"
          onClick={onClose}
        />
      </div>

      <div className="upload-dataset-modal__content">
        <Title level={4} className="upload-dataset-modal__title">
          {title}
        </Title>

        <div className="upload-dataset-modal__field">
          <Text className="upload-dataset-modal__label">
            <span className="required">*</span> {t("uploadModal.requiredLabel")}
          </Text>

          <label
            className={`upload-dataset-dropzone ${error ? "upload-dataset-dropzone--error" : ""}`}
          >
            <input
              type="file"
              accept={accept}
              hidden
              onChange={(e) => {
                const file = e.target.files?.[0] || null;
                setSelectedFile(file);
              }}
            />

            <div className="upload-dataset-dropzone__icon">
              <FileOutlined />
            </div>

            <div className="upload-dataset-dropzone__text">
              {t("uploadModal.dropzoneText")}
            </div>

            <div className="upload-dataset-dropzone__meta">{uploadMeta}</div>

            <div className="upload-dataset-dropzone__meta">
              {t("uploadModal.maxFileSize")}
            </div>

            {selectedFile && (
              <div className="upload-dataset-dropzone__filename">
                {selectedFile.name}
              </div>
            )}
          </label>

          {!!error && (
            <Text className="upload-dataset-modal__error">{error}</Text>
          )}
        </div>

        <div className="upload-dataset-modal__actions">
          <Button
            className="upload-dataset-modal__btn upload-dataset-modal__btn--secondary"
            onClick={onClose}
          >
            {t("actions.cancel")}
          </Button>
          <Button
            className="upload-dataset-modal__btn upload-dataset-modal__btn--primary"
            type="primary"
            loading={submitting}
            onClick={onSubmit}
          >
            {t("uploadModal.upload")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadDatasetModal;
